var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var newsletterFormState = function () {
	$('.newletter__input').on('focus', function () {
		$(this).parent('.newsletter__input-group').addClass('active');
	}).on('blur', function () {
		$(this).parent('.newsletter__input-group').removeClass('active');
	});
};
module.exports = newsletterFormState;